import { ISessionUser } from '../store/sessionResume.types'

export const isResumeSessionEnabled = (): boolean => {
  return process.env.REACT_APP_TOGGLE_RESUME_SESSION_FEATURE !== 'false'
}

export function getDisplayUser(sessionUser: ISessionUser | null | undefined, fallbackUserName = '') {
  return {
    firstName: sessionUser?.firstName,
    lastName: sessionUser?.lastName,
    userName: sessionUser?.userName ?? fallbackUserName,
  }
}

export function getDisplayName(firstName?: string | null, lastName?: string | null, userName?: string): string {
  const first = String(firstName ?? '').trim()
  const last = String(lastName ?? '').trim()
  const user = String(userName ?? '').trim()
  if (first || last) return [first, last].join(' ').trim()
  return user
}
